import "./CompVerif.css";
import { Input, Select, Stack, Text } from "@chakra-ui/react";

import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export default function ComapanyVerif2() {
  return (
    <>
      <div className="w-full h-full  py-5 bg-indigo-50 upper-box">
        <div>
          <Stack spacing={3}>
            <Alert status="info">
              <AlertIcon />
              Okay! Let's set up your company Account.Please help us with you
              company verification details.
            </Alert>
          </Stack>
        </div>
        <div className="w-full h-full flex justify-between Company_veri-upperbox">
          <div className="w-7/12 h-full bg-white mt-4 px-3 py-3 personal_info-box rounded">
            <div className="w-full h-20 flex items-center justify-between border-b-2">
              <div>
                <h1 className="text-lg font-semibold">Personal Identity</h1>
              </div>
              <div>
                <h1 className="text-lg font-semibold">Company Verification</h1>
              </div>
            </div>
            <div className="mt-2">
              <h1 className="text-xl font-semibold py-3">
                Let's verify your company details
              </h1>
              <p className="opacity-80 text-gray-700 font-medium">
                Provide details for using any one document number below
              </p>
            </div>
            <div className="mt-2 w-full">
              <Text className="py-2 text-black font-semibold" mb={"8px"}>Choose any one document: </Text>
              <Select placeholder="Select option">
                <option value="option1">CIN Number</option>
                <option value="option2">TAN number</option>
                <option value="option3">GST number</option>
              </Select>

              <div className="py-4">
                <Text className="text-black font-semibold" mb="8px">
                    Enter Number *:
                </Text>
                <Input
                  className=""
                  color=""
                  placeholder=""
                  _placeholder={{ color: "inherit" }}
                />
              </div>
            </div>
            <div className="mt-2">
              <h1 className="text-base font-semibold">
                We found following Company details
              </h1>
              <div className="mt-3">
                <span className="font-semibold">
                  <i class="fa-solid fa-circle-check mr-2"></i>Company name :{" "}
                </span>
                <span>{"TECHDIGI SOFTWARE PRIVATE LIMITED"}</span>
              </div>
              <div className="mt-2">
                <span className="font-semibold">
                  <i class="fa-solid fa-circle-check mr-2"></i>Address :{" "}
                </span>
                <span>{"C Sector Indrapuri bhopal MP 462022 IN "}</span>
              </div>
              <div className="mt-3">
                <Stack spacing={3}>
                  <Alert status="warning">
                    <AlertIcon />
                    By Clicking the submit and Continue. You agree and
                    Understand that the Company name will be updated as per the
                    document learn more
                  </Alert>
                </Stack>
              </div>
            </div>
            <div className="mt-4 border-t-2">
              <div className="w-full h-20 flex justify-between items-center  personal_info-box-inner ">
                <a className="text-blue-600 text-lg underline">
                  Verify using other doc
                </a>
                <div className=" flex ">
                  <Button colorScheme="blue">Back</Button>
                  <Button colorScheme="blue" className="ml-2">
                    <Link to={"/thanku"}>
                      Verify now
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="w-2/5 h-auto mt-4 Company_veri-innerbox">
            <div className="w-full h-auto bg-white px-4 py-3 rounded">
              <h1 className="text-xl font-semibold">Why Aadhar?</h1>
              <div className="mt-3 text-base flex">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/12124/12124404.png"
                  className="w-7 h-7 mr-3 mt-2"
                ></img>
                <h6>Prevent your identity from being misused by fraudsters</h6>
              </div>
              <div className="mt-3 flex ">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/187/187662.png"
                  className="w-7 h-7 mr-3 mt-2"
                ></img>
                <h6>
                  Instant OTP based verification.No other process required.
                </h6>
              </div>
              <div className="mt-3 flex ">
                <img
                  src="https://cdn.iconscout.com/icon/free/png-256/free-aadhaar-2085055-1747945.png"
                  className="w-7 h-7 mr-3 mt-2"
                ></img>
                <h6>Compliant with UIDAI & govt. regulations</h6>
              </div>
            </div>

            <div className="w-full h-auto bg-amber-100 px-4 py-3 mt-5 rounded">
              <div className="flex">
                <img
                  src="https://png.pngtree.com/png-clipart/20231003/original/pngtree-cartoon-rocket-space-ship-take-off-png-image_13244756.png"
                  className="w-9 h-9 mr-3 mt-1"
                ></img>
                <h1 className="text-xl font-semibold">One time verification</h1>
              </div>
              <div className="mt-3">
                <p className="text-black ">
                  More than{" "}
                  <span className="font-medium">1 lakh Organisations </span>have
                  already verified themselves and are receiving candidates.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3 flex">
          <i class="fa-solid fa-lock mr-3 mt-2"></i>
          <p>
            This information is used to verify your account only and kept
            confidential and protected as <br /> described in our{" "}
            <span className="underline">privacy policy</span>
          </p>
        </div>
      </div>
    </>
  );
}
